// extracted by mini-css-extract-plugin
export default {"container":"IntroPage_container__-3Oqi","snake":"IntroPage_snake__pO4m-","portfolio":"IntroPage_portfolio__RCkBo"};